module.exports = __webpack_public_path__ + "static/img/win9.a20b1fd9.png";